import { call } from 'redux-saga/effects'
import { localisedError } from '../../../utilities/Errors'
import that from '../../../utilities/translationHelper'
import { functions } from '../../../utilities/firebase'

export default function* postCommentDeleteByPostOwner({ postId, commentId }) {
	const { data: result } = yield call(functions.httpsCallable('postCommentDeleteByPostOwner'), { postId, commentId })
	if (!result.success) {
		throw localisedError(that.context.translate('Could not delete comment'), result)
	}
}



// WEBPACK FOOTER //
// ./src/redux/saga/comments/sagas.js